module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAUUlEQVRYhe3WwQkAIAxD0e7kTm7rTBUdwEuRH2ge5B4wihHWXmYOMqcAygXoCdq9hosMP0KFApMMPUEB+BHUZ1QjUYB9iAz3f2ZvLsB/y629DWChkqrijzHuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/list.png
// module id = DIj7
// module chunks = 2